import { useEffect, useRef } from 'react';

import { countryModel } from 'entities/country';
import { pharmaceuticalCompanyModel } from 'entities/pharmaceutical-company';
import { userModel } from 'entities/user';
import { VaccineDialog, vaccineModel } from 'entities/vaccine';

type Props = {
  vaccineId: string;
  isOpen: boolean;
  onClose: () => void;
  updateFn: Function;
  isSuccessUpdate: boolean;
  isLoadingUpdate: boolean;
  onDataLoaded?: () => void;
};

export const EditVaccine = ({ vaccineId, isOpen, onClose, updateFn, isLoadingUpdate, onDataLoaded }: Props) => {
  const { vaccineList } = vaccineModel.useVaccineList();
  const { data: countriesData, isLoading: isCountriesLoading } = countryModel.useAllCountries();
  const { data: pharmaCompaniesData } = pharmaceuticalCompanyModel.useLightPharmaCompanies(isOpen);
  const { data } = userModel.useUser();

  // Загружаем полные данные вакцины по ID
  const { data: vaccineData, isLoading: isLoadingVaccine } = vaccineModel.getVaccineByIdAsync(vaccineId, isOpen);

  const isDataReady = !isLoadingVaccine && !isCountriesLoading && !!vaccineData?.data;
  const hasCalledOnDataLoaded = useRef(false);

  // Вызываем onDataLoaded когда данные загружены
  useEffect(() => {
    if (isDataReady && !hasCalledOnDataLoaded.current) {
      hasCalledOnDataLoaded.current = true;
      onDataLoaded?.();
    }
  }, [isDataReady, onDataLoaded]);

  // Не показываем диалог пока данные грузятся
  if (!isDataReady) {
    return null;
  }

  return (
    <VaccineDialog
      title="Edit vaccine"
      isOpen={isOpen}
      selectedVaccine={vaccineData.data}
      onClose={onClose}
      onSubmit={updateFn}
      onVerified={updateFn}
      isLoading={isLoadingUpdate}
      userRole={data?.role}
      vaccineList={vaccineList}
      countries={countriesData?.data ?? []}
      pharmaCompanies={pharmaCompaniesData?.data ?? []}
    />
  );
};
